export type ItemNav = { id: string; rotulo: string };

/**
 * Única fonte das âncoras da página. `TODAS_AS_SECOES` (inclui `inicio`)
 * alimenta o scrollspy; `ITENS_NAV` é o subconjunto que vira link visível no
 * menu — o herói não precisa de link para si mesmo.
 */
export const ITENS_NAV: readonly ItemNav[] = [
  { id: 'auditoria-gratuita', rotulo: 'Auditoria grátis' },
  { id: 'como-funciona', rotulo: 'Como funciona' },
  { id: 'recursos', rotulo: 'Recursos' },
  { id: 'documentos', rotulo: 'Documentos' },
  { id: 'seguranca', rotulo: 'Segurança e LGPD' },
  { id: 'planos', rotulo: 'Planos' },
  { id: 'faq', rotulo: 'FAQ' },
  { id: 'contato', rotulo: 'Contato' },
] as const;

export const TODAS_AS_SECOES: readonly string[] = [
  'inicio',
  ...ITENS_NAV.map((item) => item.id),
];

// Mesma origem: o app vive em `/app` no MESMO domínio da landing (ver
// `infra/producao.yml`, roteamento por prefixo no Traefik). Relativo de
// propósito — não hardcodear o host aqui de novo.
export const URL_APP = '/app';
